import request from "@/utils/request";

// 获取案例列表
export function getCaseList(params) {
  return request({
    url: "/manage/case/list",
    method: "get",
    params,
  });
}

export function getCaseContentList(params) {
  return request({
    url: "/manage/content/list?caseCode=" + params.caseCode,
    method: "get",
  });
}

// 列表
export function getHouseList(params) {
  return request({
    url: "/manage/content/list",
    method: "get",
    params,
  });
}

// 详情
export function getHouseDetail(params) {
  return request({
    url: "/manage/content/getSceneDetails/" + params.id,
    method: "get",
  });
}

// 查询内容管理-全部场景类型列表

export function allListType(query) {
  return request({
    url: "/manage/type/listAll",
    method: "get",
    params: query,
  });
}

// 内容管理 - 删除内容
export function deleteContentCourse(params) {
  return request({
    url: "/manage/content/" + params.id,
    method: "delete",
  });
}

// 主页展示课程列表
export function homePageCards(params) {
  return request({
    url: "/manage/subject/public/homePageCards",
    method: "get",
    params,
  });
}

// 内容管理标签
export function getContentTags(params) {
  return request({
    url: "/manage/tags/all",
    method: "get",
    params,
  });
}

// 内容管理 - 课程编辑;
export function editCourse(params) {
  return request({
    url: "/manage/subject",
    method: "put",
    data: params,
  });
}

// 内容管理 - 新增;
export function addCourse(params) {
  return request({
    url: "/manage/subject",
    method: "post",
    data: params,
  });
}

// 内容考核中分页
export function getContentAssessments(params) {
  return request({
    url: "/manage/subject/assessment",
    method: "get",
    params,
  });
}

// 内容编辑中分页
export function getContentEditings(params) {
  return request({
    url: "/manage/subject/editing",
    method: "get",
    params,
  });
}

// 历史分页
export function getContentHistories(params) {
  return request({
    url: "/manage/subject/history",
    method: "get",
    params,
  });
}

// 内容详情
export function getContentDetail(params) {
  return request({
    url: "/manage/subject/" + params.urlCode,
    method: "get",
  });
}

// 课程管理 - 删除课程
export function deleteCourse(params) {
  return request({
    url: "/manage/subject/" + params.id,
    method: "delete",
  });
}

// 登录
export function login(data) {
  return request({
    url: "/login",
    headers: {
      isToken: false,
      repeatSubmit: false,
    },
    method: "post",
    data: data,
  });
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: "/getInfo",
    method: "get",
  });
}

// 验证码
export function getCodeImg() {
  return request({
    url: "/captchaImage",
    headers: {
      isToken: false,
    },
    method: "get",
    timeout: 20000,
  });
}

// 内容排序功能
export function contentSort(data) {
  return request({
    url: "/manage/content/sort",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
}

// 创建ai案例
export function buildAi(data) {
  return request({
    url: "/ai/build",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
}

// 退出登录
export function logout(data) {
  return request({
    url: "/logout",
    method: "post",
    data,
  });
}

// 获取用户信息
export function getPublicSubjectList(params) {
  return request({
    url: "/manage/subject/public/list",
    method: "get",
    params,
  });
}

// 用户回答
export function userAnswer(data) {
  return request({
    url: "/manage/answer/userAnswer",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
}

// 用户回答
export function getSkyDetail(params) {
  return request({
    url: "/manage/case/detail/" + params.id,
    method: "get",
  });
}

// 创建ai案例

export function getStudent(data) {
  return request({
    url: "/manage/subject/getStudent/" + data.code,
    method: "get",
  });
}

// 创建ai案例
export function getStudentScore(data) {
  return request({
    url: "/manage/subject/getStudentScore",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
}
